// collectionApi.ts
import { APIFinalArgs, QueryResponse } from '@common/types/queryState';
import { apiPaths, baseApi } from '@services';
import { transformCollection, transformMetricsCollection } from '../mappers';
import {
    BackendCollection,
    Collection,
    GetCollectionsArgs,
    GetMetricsCollectionArgs,
    MetricsCollection,
} from '../types';
import { transformQueryResponse } from '@common/utils';

const extendedApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCollections: builder.query<
            QueryResponse<Collection>,
            APIFinalArgs<GetCollectionsArgs>
        >({
            query: ({ productionId, params }) => ({
                url: apiPaths.data.getCollections(productionId),
                params,
            }),
            providesTags: () => [{ type: 'Collection', id: 'LIST' }],
            transformResponse: (response: BackendCollection[], meta, arg) =>
                transformQueryResponse(
                    response,
                    meta,
                    arg,
                    transformCollection,
                ),
        }),
        getCollectionAssetIds: builder.query<
            QueryResponse<Collection>,
            APIFinalArgs<GetCollectionsArgs>
        >({
            query: ({ productionId, params }) => ({
                url: apiPaths.data.getCollections(productionId),
                params,
            }),
            providesTags: () => [{ type: 'CollectionAssetIds', id: 'LIST' }],
            transformResponse: (response: BackendCollection[], meta, arg) =>
                transformQueryResponse(
                    response,
                    meta,
                    arg,
                    transformCollection,
                ),
        }),
        getMetricsCollection: builder.query<
            MetricsCollection,
            GetMetricsCollectionArgs
        >({
            query: ({ productionId }) => ({
                url: apiPaths.data.getCollections(productionId),
                params: {
                    fq: ['title_lc:zz_frontOfficeData'],
                },
            }),
            providesTags: () => [{ type: 'Collection', id: 'METRICS' }],
            transformResponse: (response: BackendCollection[], meta, args) =>
                transformMetricsCollection(response?.[0], meta, args),
        }),
    }),
});

export const {
    useGetCollectionsQuery,
    useLazyGetCollectionsQuery,

    useGetCollectionAssetIdsQuery,
    useLazyGetCollectionAssetIdsQuery,

    useGetMetricsCollectionQuery,
    useLazyGetMetricsCollectionQuery,
} = extendedApi;

export default extendedApi.endpoints;
